import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { GET_AUTH_REQUEST, LOGOUT_REQUEST } from 'app/dealer/login/constants';
import { SET_USER_STATE } from 'app/shared/modules/user/constants';

import { apiCallSaga } from '../apiCall/sagas';
import DEALERS_INSIGHTS_API from '../../api/dealersInsights.api';
import { selectCurrentDealerId, selectCurrentLevel } from '../level/selectors';
import { DEALERS_INSIGHTS_LEVELS } from '../level/constants';

import {
  fetchDateRangeError,
  fetchDateRangeSuccess,
  resetDateRangeState,
  dateRangeApiProgressActions,
} from './actions';
import { selectDateRangeByFilteredLevel } from './selectors';
import { DateRangeActionTypes } from './constants';

export function* getDateRangeValuesAsync({ manuallySetCacheLevel } = {}) {
  const currentDealerId = yield select(selectCurrentDealerId);
  let currentLevel;

  // allows us to request data from levels that
  // are not currently selected (this is a UI optimization)
  if (manuallySetCacheLevel) {
    currentLevel = manuallySetCacheLevel;
  } else {
    currentLevel = yield select(selectCurrentLevel);
  }

  const params = {};
  if (currentLevel === DEALERS_INSIGHTS_LEVELS.DEALER && currentDealerId) {
    params.dealerId = currentDealerId;
  }

  const dateRangeApiUrl = yield DEALERS_INSIGHTS_API.dateRange(params);
  const { result, error } = yield call(
    apiCallSaga,
    dateRangeApiUrl,
    dateRangeApiProgressActions,
  );
  if (error) {
    yield put(fetchDateRangeError(error));
    return false;
  }
  yield put(fetchDateRangeSuccess({ result, currentLevel, currentDealerId }));
  return true;
}

export function* getDateRangeAsync() {
  /**
   * @constant
   * @type {{firstDate: string, lastDate: string}}
   */
  const currentlyFilteredLevelDateRange = yield select(
    selectDateRangeByFilteredLevel,
  );

  // only fetch date range values if they do not exist in the store
  if (!currentlyFilteredLevelDateRange) {
    const dateRangePresent = yield call(getDateRangeValuesAsync);
    return dateRangePresent;
  }

  return true;
}

export function* triggerResetDateRangeState() {
  yield put(resetDateRangeState());
}

// refresh data for login, logout, and returning users
export function* watchUserAuthStatus() {
  yield takeLatest(
    [GET_AUTH_REQUEST, LOGOUT_REQUEST, SET_USER_STATE],
    triggerResetDateRangeState,
  );
}

export function* watchGetDateRange() {
  yield takeLatest(DateRangeActionTypes.GET_DATE_RANGE, getDateRangeAsync);
}

export function* watchDateRangeSagas() {
  yield all([call(watchGetDateRange), call(watchUserAuthStatus)]);
}
